import { z } from 'zod';

export const commentFormSchema = z.object({
  content: z.string().min(1),
});

export type CommentFormType = z.infer<typeof commentFormSchema>;
